export class Location {
    lattitude: number;
    longitude: number;

    constructor(lattitude: number, longitude: number) {
        this.lattitude = lattitude
        this.longitude = longitude
    }

    distanceFrom(otherLocation: Location): Array<number> {
      return [
        Math.abs(parseFloat((otherLocation.lattitude - this.lattitude).toFixed(6))),
        Math.abs(parseFloat((otherLocation.longitude - this.longitude).toFixed(6))),
      ]
    }
}
